import builder from '../builder';
import SocialMediaTwitter from '../../streamline-icons/light/social-media-twitter.svg';

export default builder('IconSocialMediaTwitterLight', SocialMediaTwitter);
